// source: pbtypes/vehicle/complimentary_actions/complimentary_actions_impls/spoof_photo_response/spoof_photo_response.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_vehicle_complimentary_actions_trigger_args_pb = require('../../../../../pbtypes/vehicle/complimentary_actions/trigger_args_pb.js');
goog.object.extend(proto, pbtypes_vehicle_complimentary_actions_trigger_args_pb);
goog.exportSymbol('proto.complimentary_actions.SpoofPhotoResponseActionArgs', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.complimentary_actions.SpoofPhotoResponseActionArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.complimentary_actions.SpoofPhotoResponseActionArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.complimentary_actions.SpoofPhotoResponseActionArgs.displayName = 'proto.complimentary_actions.SpoofPhotoResponseActionArgs';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.complimentary_actions.SpoofPhotoResponseActionArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.complimentary_actions.SpoofPhotoResponseActionArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.complimentary_actions.SpoofPhotoResponseActionArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.SpoofPhotoResponseActionArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
trigger: (f = msg.getTrigger()) && pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.ChannelCallback.toObject(includeInstance, f),
spoofStartTriggerIdx: jspb.Message.getFieldWithDefault(msg, 2, 0),
spoofEndTriggerIdx: jspb.Message.getFieldWithDefault(msg, 3, 0),
photoCaptureResult: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.complimentary_actions.SpoofPhotoResponseActionArgs}
 */
proto.complimentary_actions.SpoofPhotoResponseActionArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.complimentary_actions.SpoofPhotoResponseActionArgs;
  return proto.complimentary_actions.SpoofPhotoResponseActionArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.complimentary_actions.SpoofPhotoResponseActionArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.complimentary_actions.SpoofPhotoResponseActionArgs}
 */
proto.complimentary_actions.SpoofPhotoResponseActionArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.ChannelCallback;
      reader.readMessage(value,pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.ChannelCallback.deserializeBinaryFromReader);
      msg.setTrigger(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSpoofStartTriggerIdx(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSpoofEndTriggerIdx(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPhotoCaptureResult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.complimentary_actions.SpoofPhotoResponseActionArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.complimentary_actions.SpoofPhotoResponseActionArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.complimentary_actions.SpoofPhotoResponseActionArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.SpoofPhotoResponseActionArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrigger();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.ChannelCallback.serializeBinaryToWriter
    );
  }
  f = message.getSpoofStartTriggerIdx();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getSpoofEndTriggerIdx();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getPhotoCaptureResult();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional TriggerArgs.ChannelCallback trigger = 1;
 * @return {?proto.complimentary_actions.TriggerArgs.ChannelCallback}
 */
proto.complimentary_actions.SpoofPhotoResponseActionArgs.prototype.getTrigger = function() {
  return /** @type{?proto.complimentary_actions.TriggerArgs.ChannelCallback} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.ChannelCallback, 1));
};


/**
 * @param {?proto.complimentary_actions.TriggerArgs.ChannelCallback|undefined} value
 * @return {!proto.complimentary_actions.SpoofPhotoResponseActionArgs} returns this
*/
proto.complimentary_actions.SpoofPhotoResponseActionArgs.prototype.setTrigger = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.complimentary_actions.SpoofPhotoResponseActionArgs} returns this
 */
proto.complimentary_actions.SpoofPhotoResponseActionArgs.prototype.clearTrigger = function() {
  return this.setTrigger(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.complimentary_actions.SpoofPhotoResponseActionArgs.prototype.hasTrigger = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint32 spoof_start_trigger_idx = 2;
 * @return {number}
 */
proto.complimentary_actions.SpoofPhotoResponseActionArgs.prototype.getSpoofStartTriggerIdx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.complimentary_actions.SpoofPhotoResponseActionArgs} returns this
 */
proto.complimentary_actions.SpoofPhotoResponseActionArgs.prototype.setSpoofStartTriggerIdx = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 spoof_end_trigger_idx = 3;
 * @return {number}
 */
proto.complimentary_actions.SpoofPhotoResponseActionArgs.prototype.getSpoofEndTriggerIdx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.complimentary_actions.SpoofPhotoResponseActionArgs} returns this
 */
proto.complimentary_actions.SpoofPhotoResponseActionArgs.prototype.setSpoofEndTriggerIdx = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 photo_capture_result = 4;
 * @return {number}
 */
proto.complimentary_actions.SpoofPhotoResponseActionArgs.prototype.getPhotoCaptureResult = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.complimentary_actions.SpoofPhotoResponseActionArgs} returns this
 */
proto.complimentary_actions.SpoofPhotoResponseActionArgs.prototype.setPhotoCaptureResult = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


goog.object.extend(exports, proto.complimentary_actions);
